import { render, staticRenderFns } from "./add_to_tree.vue?vue&type=template&id=0a195012&vue3"
import script from "./add_to_tree.vue?vue&type=script&lang=js&vue3"
export * from "./add_to_tree.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports